/* Polsk katalog for locale-support-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'nav.support': 'Pomoc techniczna',
  'navhelp.support': 'Przeglądaj i śledź zgłoszenia do pomocy technicznej, które wysłałeś.',
  'route.support': 'Pomoc techniczna',
  'support.title': 'Pomoc techniczna',
  'support.contact': 'Skontaktuj się z pomocą techniczną',
  'support.close': 'Zamknij',
  'support.send': 'Wyślij',
  'support.sending': 'Wysyłanie…',
  'support.editor.toolbar': 'Formatowanie wiadomości',
  'support.editor.bold': 'Pogrubienie',
  'support.editor.italic': 'Kursywa',
  'support.editor.underline': 'Podkreślenie',
  'support.editor.bullets': 'Lista punktowana',
  'support.editor.numbered': 'Lista numerowana',
  'support.editor.list': 'Lista',
  'support.editor.link': 'Link',
  'support.editor.linkPrompt': 'Wklej link http:// lub https://',
  'support.editor.image': 'Obraz',
  'support.editor.screenshot': 'Zrzut ekranu',
  'support.editor.screenshotLabel': 'Dołącz zrzut ekranu bieżącego widoku',
  'support.editor.capturing': 'Wykonywanie zrzutu ekranu…',
  'support.editor.pendingImages': 'Obrazy gotowe do wysłania',
  'support.editor.removeImage': 'Usuń obraz',
  'support.editor.openImage': 'Otwórz obraz',
  'support.editor.optimizing': 'Optymalizowanie obrazów…',
  'support.retry': 'Spróbuj ponownie',
  'support.back': 'Wróć do zgłoszeń',
  'support.category': 'Kategoria',
  'support.category.feil': 'Błąd / coś nie działa',
  'support.category.fakturering': 'Rozliczenia i płatności',
  'support.category.sporsmal': 'Pytanie ogólne',
  'support.category.annet': 'Inne',
  'support.subject': 'Temat',
  'support.subject.placeholder': 'Krótki opis sprawy',
  'support.message': 'Wiadomość',
  'support.message.placeholder': 'Opisz, co się dzieje, najlepiej ze szczegółami',
  'support.sent.title': 'Zgłoszenie zostało wysłane',
  'support.sent.text': 'Otrzymaliśmy {id} i odezwiemy się najszybciej, jak to możliwe.',
  'support.new.title': 'Nowe zgłoszenie',
  'support.new.action': 'Nowe zgłoszenie',
  'support.filter.label': 'Filtruj zgłoszenia',
  'support.filter.all': 'Wszystkie',
  'support.filter.open': 'Otwarte',
  'support.filter.closed': 'Zamknięte',
  'support.table.ticket': 'Zgłoszenie',
  'support.table.category': 'Kategoria',
  'support.table.sent': 'Wysłano',
  'support.table.lastReply': 'Ostatnia odpowiedź',
  'support.lastReply.you': 'Ty',
  'support.lastReply.support': 'Pomoc techniczna',
  'support.table.status': 'Status',
  'support.status.open': 'Otwarte',
  'support.status.closed': 'Zamknięte',
  'support.opened': 'Otwarto {date}',
  'support.closeTicket': 'Oznacz jako zamknięte',
  'support.table.actions': 'Działania',
  'support.delete.rowAction': 'Usuń',
  'support.delete.rowLabel': 'Usuń zgłoszenie {{id}}',
  'support.delete.action': 'Usuń zgłoszenie',
  'support.delete.title': 'Usunąć zgłoszenie?',
  'support.delete.confirm': 'Usuń',
  'support.delete.text': 'Zgłoszenie zostanie usunięte z twojej listy, a jego wiadomości nie będą już dla ciebie dostępne.',
  'support.delete.done': 'Zgłoszenie zostało usunięte.',
  'support.error.delete': 'Nie udało się usunąć zgłoszenia. Spróbuj ponownie.',
  'support.reopen.action': 'Otwórz ponownie',
  'support.reopen.title': 'Otworzyć zgłoszenie ponownie?',
  'support.reopen.confirm': 'Otwórz mimo to',
  'support.reopen.text': 'Otwieraj ponownie tylko wtedy, gdy chodzi o ten sam problem, którego dotyczyło zgłoszenie. Jeśli to nowa sprawa, utwórz nowe zgłoszenie.',
  'support.you': 'Ty',
  'support.agent': 'Pomoc techniczna',
  'support.reply.placeholder': 'Kontynuuj rozmowę – napisz wiadomość do pomocy technicznej',
  'support.closed.note': 'To zgłoszenie jest zamknięte. Możesz przeglądać historię, ale nie możesz wysyłać kolejnych wiadomości.',
  'support.empty.title': 'Brak zgłoszeń',
  'support.empty.filterTitle': 'Brak zgłoszeń w tym filtrze',
  'support.empty.text': 'Zgłoszenia wysłane za pomocą przycisku pomocy technicznej pojawią się tutaj.',
  'support.loading.list': 'Pobieranie zgłoszeń…',
  'support.loading.thread': 'Pobieranie rozmowy…',
  'support.error.required': 'Wpisz zarówno temat, jak i wiadomość.',
  'support.error.noBusiness': 'Wybierz firmę przed skontaktowaniem się z pomocą techniczną.',
  'support.error.create': 'Nie udało się wysłać zgłoszenia. Spróbuj ponownie.',
  'support.error.list': 'Nie udało się pobrać zgłoszeń.',
  'support.error.thread': 'Nie udało się pobrać rozmowy.',
  'support.error.reply': 'Nie udało się wysłać wiadomości. Spróbuj ponownie.',
  'support.error.status': 'Nie udało się zaktualizować statusu.',
  'support.error.link': 'Wpisz prawidłowy link http:// lub https://.',
  'support.error.imageType': 'Używaj obrazów w formacie JPEG, PNG, GIF lub WebP.',
  'support.error.imageSourceSize': 'Każdy oryginalny obraz może mieć maksymalnie 20 MB.',
  'support.error.imageSourceTotal': 'Oryginalne obrazy mogą mieć łącznie maksymalnie 40 MB na jeden wybór.',
  'support.error.imageCount': 'Możesz dołączyć maksymalnie cztery obrazy.',
  'support.error.imageSize': 'Obraz po optymalizacji nadal przekracza 5 MB.',
  'support.error.imageTotal': 'Zoptymalizowane obrazy mogą mieć łącznie maksymalnie 10 MB na wiadomość.',
  'support.error.imageOptimize': 'Nie udało się zoptymalizować obrazu. Spróbuj mniejszego obrazu.',
  'support.error.screenshot': 'Nie udało się wykonać zrzutu ekranu. Spróbuj ponownie lub dołącz obraz ręcznie.',
  'support.error.imagesUnavailable': 'Wysyłanie obrazów wymaga zaktualizowanej usługi pomocy technicznej. Odśwież stronę i spróbuj ponownie.',
  'support.error.requestTimedOut': 'Usługa pomocy technicznej nie odpowiedziała. Spróbuj ponownie.',
  'support.page.tickets': 'Zgłoszenia',
  'support.page.articles': 'Artykuły',
  'support.articles.back': 'Wróć do artykułów',
  'support.articles.search.label': 'Szukaj w artykułach pomocy',
  'support.articles.categories': 'Kategorie',
  'support.articles.results': 'Znalezione artykuły: {count}',
  'support.articles.empty.title': 'Nie znaleziono artykułów',
  'support.articles.empty.text': 'Spróbuj innego wyszukiwanego hasła lub wybierz inną kategorię.',
  'support.articles.clear': 'Wyczyść wyszukiwanie i filtr',
  'support.pages.label': 'Wybierz stronę pomocy',
  'support.articles.search.placeholder': 'Szukaj w artykułach pomocy',
  'support.articles.count.one': 'Artykuły: {count}',
  'support.articles.count.other': 'Artykuły: {count}',
  'support.articles.resultsTitle': 'Wyniki wyszukiwania',
  'err.nativeValidation.backend-support.1': 'Nieprawidłowa odpowiedź przy usuwaniu zgłoszenia.',
});
